import { Primary } from "../../components/buttons/Primary";
import { SimulatorCuotas } from "../../components/credits/SimulatorCuotas";

export function AcuotasPage() {
  return (
    <div className="bg-red bg-opacity-10 overflow-hidden pt-10 font-walsheim">
      <div className="pt-6 pb-16 sm:pb-24">
        <main className="mt-16 sm:mt-18">
          <div className="mx-auto max-w-7xl">
            <div className="lg:grid lg:grid-cols-12 lg:gap-8">
              <div className="px-4 sm:px-6 sm:text-center md:max-w-2xl md:mx-auto lg:col-span-6 lg:text-left lg:flex lg:items-center">
                <div>
                  <h1 className="mt-4 text-4xl tracking-tight font-bold sm:mt-5 sm:leading-none lg:mt-6 lg:text-5xl xl:text-6xl">
                    <span className="md:block">
                      Felicidades Miguel, puedes continuar con tu crédito.
                    </span>{" "}
                  </h1>
                  <p className="py-8 text-xl">
                    Te hemos preaprobado hasta $3.000.000 con plazo entre 3 y 6 cuotas.
                  </p>
                </div>
              </div>
              <div className="mt-0 px-2 sm:mt-24 lg:mt-0 lg:col-span-6">
                <div className="bg-white shadow-lg sm:max-w-md sm:w-full sm:mx-auto rounded-lg sm:overflow-hidden">
                  <div className="px-4 py-8 sm:px-10">
                    <div>
                      <h3 className="font-medium text-2xl text-center">
                        Confirma tu crédito
                      </h3>
                    </div>
                    <div className="mt-6">
                      <form action="#" method="GET" className="space-y-6">
                        <SimulatorCuotas
                          title={"Elige el monto"}
                          title2={"Elige las cuotas"}
                          maxAmn={3000000}
                          minAmn={1000000}
                          step={100000}
                          default={1500000}
                          maxFee={6}
                          minFee={3}
                          stepFee={1}
                          feeDefault={4}
                        />
                        <div>
                          <Primary text="Aceptar crédito" />
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
